export const convertTimeStampToDate = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  if (value !== null || value !== undefined) {
    let [year, month, day] = value.split("-");
    let formatedDay = day.split("T")[0];
    return `${month}/${formatedDay}/${year}`;
  }
};

export const formatUnixTime = (unixTime) => {
  if (unixTime !== null && unixTime !== undefined) {
    let newDate = new Date(parseInt(unixTime));
    return newDate;
  } else return new Date("01/01/1000");
};

export const convertTimeStampLocalDateTime = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  if (value !== null || value !== undefined) {
    // convert timestamp to local date and time
    const oldDate = new Date(value);
    let localDate = oldDate.toLocaleString();
    return localDate;
  }
};